import React, { useEffect } from "react";
import { buildVersion } from "../services/buildInfo";

function ThankYou() {

  // Adobe DataLayer (KEPT)
  useEffect(() => {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push({
      event: "pageView",
      web: {
        webPageDetails: {
          pageViews: { value: 1 },
          name: "icicibank:in:en:campaign:accounts:casa:savingsaccount:onboarding:eligible thankyou page",
          URL: window.location.href,
          isErrorPage: "False",
        },
      },
      _icicibank: {
        channelInfo: { version: buildVersion, name: "nli" },
        pageInfo: {
          language: "en",
          country: "in",
          pageType: "campaign",
          virtualPageView: "no vpv",
          journey: "na",
          subJourney: "na",
          subSubJourney: "na",
        },
        userInfo: { userType: "na" },
        errorInfo: { errorType: "na", errorDetails: "na" },
      },
    });
  }, []);

  // Google Ads gtag — Remarketing (AW-961178487, AW-848956189, AW-736858127, AW-11185178531) + Conversion (AW-736858127)
  // useEffect(() => {
  //   if (document.getElementById("gtag-remarketing")) return;

  //   window.dataLayer = window.dataLayer || [];
  //   function gtag() { window.dataLayer.push(arguments); }
  //   window.gtag = gtag;

  //   const script = document.createElement("script");
  //   script.id = "gtag-remarketing";
  //   script.async = true;
  //   script.src = "https://www.googletagmanager.com/gtag/js?id=AW-961178487";
  //   document.head.appendChild(script);

  //   gtag("js", new Date());

  //   // Remarketing configs
  //   gtag("config", "AW-961178487");
  //   gtag("config", "AW-848956189");
  //   gtag("config", "AW-736858127");
  //   gtag("config", "AW-11185178531");

  //   // Conversion event
  //   gtag("event", "conversion", { send_to: "AW-736858127/r6u3CN_v1J4YEI-grt8C" });
  // }, []);


  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=DC-8971752";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = window.gtag || gtag;
      window.gtag("js", new Date());
      window.gtag("config", "DC-8971752");
      window.gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-8971752/invmedia/saving03+standard",
      });
    };
  }, []);

  useEffect(() => {
    if (document.getElementById("gtag-remarketing")) return;

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;

    const userData = localStorage.getItem("userData");
    const retrievedData = userData ? JSON.parse(userData) : null;

    const script = document.createElement("script");
    script.id = "gtag-remarketing";
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-961178487";
    document.head.appendChild(script);

    script.onload = () => {
      gtag("js", new Date());

      // Remarketing configs
      gtag("config", "AW-961178487");
      gtag("config", "AW-848956189");
      gtag("config", "AW-11185178531", { send_page_view: true });

      // ECL on AW-736858127
      if (retrievedData?.mobile) {
        gtag("set", "user_data", { phone_number: retrievedData.mobile });
      }
      gtag("config", "AW-736858127", { allow_enhanced_conversions: true, send_page_view: true });

      // Conversion event
      gtag("event", "conversion", { send_to: "AW-736858127/r6u3CN_v1J4YEI-grt8C" });

      // Form submit event
      gtag("event", "form_submit", { send_to: "AW-736858127" });
    };

    // Remove userData from localStorage after 4 seconds using a separate function
    function removeUserData() {
      localStorage.removeItem("userData");
    }
    setTimeout(removeUserData, 4000);
  }, []);

  // Facebook Pixel — Remarketing (PageView) + Conversion (SA-ApplyNow)
  useEffect(() => {
    if (window.fbEventFired) return;
    window.fbEventFired = true;

    if (!window.fbq) {
      (function (f, b, e, v, n, t, s) {
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    }

    window.fbq("init", "1109423764622443");
    window.fbq("track", "PageView");                  // Remarketing
    window.fbq("trackCustom", "SA-ApplyNow");          // Conversion
  }, []);

  // LinkedIn Insight Tag — partner ID 5534113
  useEffect(() => {
    if (document.getElementById("linkedin-insight")) return;

    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push("5534113");

    (function (l) {
      if (!l) {
        window.lintrk = function (a, b) { window.lintrk.q.push([a, b]); };
        window.lintrk.q = [];
      }
      var s = document.getElementsByTagName("script")[0];
      var b = document.createElement("script");
      b.id = "linkedin-insight";
      b.type = "text/javascript";
      b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      s.parentNode.insertBefore(b, s);
    })(window.lintrk);
  }, []);

  // Bing UET Tags — 97231495 and 97231496
  useEffect(() => {
    if (document.getElementById("bing-uet")) return;

    window.uetq = window.uetq || [];
    window.uetq2 = window.uetq2 || [];

    const script = document.createElement("script");
    script.id = "bing-uet";
    script.src = "https://bat.bing.com/bat.js";
    script.async = true;
    script.onload = () => {
      window.uetq = new window.UET({ ti: "97231495", q: window.uetq });
      window.uetq.push("pageLoad");

      window.uetq2 = new window.UET({ ti: "97231496", q: window.uetq2 });
      window.uetq2.push("pageLoad");
    };
    document.body.appendChild(script);
  }, []);

  // MS Clarity — vn9y1utxz2
  useEffect(() => {
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "vn9y1utxz2");
  }, []);

  return (
    <article className="thankyou_sec">
      <style>{`
        .thankyou_sec .thankyou_heading {
          font-family: "Mulish", sans-serif;
          font-weight: 800;
          color: #E4792D;
          text-align: center;
          font-size: 31px;
          margin: 20% 0 20px;
        }
        .thankyou_sec .tick {
          margin-top: 0;
        }
        .thankyou_sec .thankyou_txt p {
          color: #E4792D;
        }
        @media screen and (max-width: 1440.5px) {
          .thankyou_sec .thankyou_heading {
            font-size: 25px;
            margin-top: 14%;
          }
        }
        @media screen and (max-width: 1199.5px) {
          .thankyou_sec .thankyou_heading {
            margin-top: 40%;
          }
        }
        @media screen and (max-width: 767.5px) {
          .thankyou_sec .thankyou_heading {
            font-size: 21px;
            margin-top: 50%;
          }
          .thankyou_sec .container {
            margin-top: -50px;
          }
          .thankyou_sec .thankyou_txt.mobile-readable p {
            line-height: 1.2;
            margin-bottom: 20px;
          }
          .thankyou_sec .thankyou_txt.mobile-readable p:last-child {
            margin-bottom: 0;
          }
        }
      `}</style>
      <div className="container ">
        <h2 className="thankyou_heading">ICICI 3-in-1 Savings Account</h2> 
        <div className="tick">
          <img
            src="../dist/img/tick.webp"
            alt="tick"
            width="100"
            height="100"
            className="img-fluid"
          />
        </div>
        <div className="thankyou_txt mobile-readable">
          <p>
            Thank you for your interest. Your submission is complete.
          </p>
          <p>
            We are currently reviewing your details to ensure that we provide you with the most relevant options for your profile.
          </p>
          <p>
            If applicable, one of our representatives will contact you shortly from a number starting with 1600 31 XXXX to take things forward.
          </p>
        </div>
      </div>
    </article>
  );
}

export default ThankYou;
